import Axios from 'axios';

const BASE_URL =  "/api/sms";

export default {

    send(data) {
        return Axios.post(BASE_URL + "/send", data);
      },
    getBalance() {
       // return Axios.get(BASE_URL+"/api/smsapibalance?key="+key);
       return Axios.get(BASE_URL+"/balance");
    },

    async sendFeeReminder(store, { feepayments, selbill = null, sms_balance = 0 }) {
      const notify = (type, text) =>
        store.dispatch("responseMessage", {
          type,
          text,
          title: "SMS",
          modal: false
        });

      let msg_contents = [];
      if (selbill && selbill.s_guardian && selbill.s_guardian.phone) {
        msg_contents = [
          {
            grd_phone: selbill.s_guardian.phone,
            balance: selbill.remaining_fee,
            ward: selbill.s_bio.name
          }
        ];
      } else {
        msg_contents = feepayments
          .filter(x => {
            if (x.fee_status == "owing" && x.s_guardian && x.s_guardian.phone) {
              return true;
            }
          })
          .map(rs => {
            return {
              grd_phone: rs.s_guardian.phone,
              balance: rs.remaining_fee,
              ward: rs.s_bio.name
            };
          });
      }

      if (!msg_contents.length) {
        notify(
          "warning",
          "Sorry, there are no recipients with a phone number for this SMS."
        );
        return { sent: 0, skipped: 0 };
      }

      if (sms_balance < msg_contents.length) {
        notify(
          "warning",
          "Sorry,your balance is insufficient for this message. Please tell administrator to recharge sms balance."
        );
        return { sent: 0, skipped: 0 };
      }

      const messages = msg_contents.map(x => ({
        to: x.grd_phone,
        msg:
          "Hello, please this is a reminder to pay " +
          x.ward +
          "'s remaining school fees of GHS " +
          (parseFloat(x.balance) || 0).toFixed(2) +
          ". We look forward to hearing from you soon."
      }));

      try {
        await store.dispatch("sms/send", { messages });
        store.dispatch("sms/getBalance");
        notify("success", "Message sent successfully.");
        return { sent: msg_contents.length, skipped: 0 };
      } catch (e) {
        notify("warning", "Sorry,message could not be sent.");
        return { sent: 0, skipped: 0 };
      }
    },



}



// WEBPACK FOOTER //
// ./resources/assets/js/services/sms.js